import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useRef, useEffect, useLayoutEffect } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import ResizeObserver from "resize-observer-polyfill";

var DropdownItem = function DropdownItem(_ref) {
  var _item$customLabel;

  var getClassName = _ref.getClassName,
      getItemHeight = _ref.getItemHeight,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      item = _ref.item,
      linkRef = _ref.linkRef,
      onBlur = _ref.onBlur,
      onItemClicked = _ref.onItemClicked,
      withCheckmark = _ref.withCheckmark;
  var itemElement = useRef(null);
  var observer = React.useRef(new ResizeObserver(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
        dropdownItem = _ref3[0];

    var height = dropdownItem.contentRect.height;

    if (getItemHeight) {
      getItemHeight(height);
    }
  }));
  useLayoutEffect(function () {
    if (itemElement.current && getItemHeight) {
      observer.current.observe(itemElement.current);
    }

    return function () {
      if (itemElement.current && getItemHeight) {
        observer.current.unobserve(itemElement.current);
      }
    };
  }, [itemElement, observer, getItemHeight]);
  useEffect(function () {
    if (isFocused && itemElement.current) {
      itemElement.current.firstElementChild.focus();
    }
  }, [isFocused]);
  var a11yProps = {
    "aria-selected": isSelected,
    role: "option",
    tabIndex: 0
  };
  var shouldShowCheckmark = isSelected && withCheckmark;
  var labelValue = (_item$customLabel = item === null || item === void 0 ? void 0 : item.customLabel) !== null && _item$customLabel !== void 0 ? _item$customLabel : item.label;
  var span = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "itemInnerText"
    })
  }, labelValue));
  var clickable; // Switch between <a> and <button> based on whether has href or value

  if (item.href) {
    clickable = /*#__PURE__*/React.createElement("a", {
      id: item.value ? item.value.toString() : "",
      className: getClassName({
        descendantName: "itemInner",
        modifiers: classNames({
          focused: isFocused,
          withCheckmark: shouldShowCheckmark
        })
      }),
      href: item.href,
      ref: linkRef
    }, span);
  } else {
    clickable = /*#__PURE__*/React.createElement("button", {
      id: item.value ? item.value.toString() : "",
      className: "".concat(getClassName({
        descendantName: "itemInner",
        modifiers: classNames({
          focused: isFocused,
          withCheckmark: shouldShowCheckmark
        })
      }), " ").concat(getClassName({
        descendantName: "itemInnerButton",
        modifiers: isSelected ? "selected" : null
      })),
      tabIndex: 0 // preventing losing focus from the parent UL element to keep accessibility features working
      ,
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        onItemClicked(item, e);
      }
    }, span);
  }

  return /*#__PURE__*/React.createElement("li", _extends({
    ref: itemElement
  }, a11yProps, {
    className: getClassName({
      descendantName: "item"
    }),
    onBlur: onBlur
  }), clickable);
};

DropdownItem.displayName = "DropdownItem";
DropdownItem.propTypes = {
  getClassName: PropTypes.func.isRequired
};
export default DropdownItem;